import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'

export const LocationSelectorFallback = () => (
  <div className="w-full">
    <Label>Location</Label>
    <Skeleton className="h-9 w-full mt-2" />
  </div>
)
